/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 *
 * @export
 * @interface PalAuthSubmissionDraftFormData
 */
export interface PalAuthSubmissionDraftFormData {
    /**
     *
     * @type {string}
     * @memberof PalAuthSubmissionDraftFormData
     */
    form_id: string;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof PalAuthSubmissionDraftFormData
     */
    values: { [key: string]: any; };
    /**
     *
     * @type {string}
     * @memberof PalAuthSubmissionDraftFormData
     */
    saved_at: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionDraftFormData interface.
 */
export function instanceOfPalAuthSubmissionDraftFormData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_id" in value;
    isInstance = isInstance && "values" in value;
    isInstance = isInstance && "saved_at" in value;

    return isInstance;
}

export function PalAuthSubmissionDraftFormDataFromJSON(json: any): PalAuthSubmissionDraftFormData {
    return PalAuthSubmissionDraftFormDataFromJSONTyped(json, false);
}

export function PalAuthSubmissionDraftFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionDraftFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'form_id': json['form_id'],
        'values': json['values'],
        'saved_at': json['saved_at'],
    };
}

export function PalAuthSubmissionDraftFormDataToJSON(value?: PalAuthSubmissionDraftFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'form_id': value.form_id,
        'values': value.values,
        'saved_at': value.saved_at,
    };
}

